import api from "@/lib/api";

export default {
  getAllGroups() {
    return api.get("/api/v1/adm/user/get-all-groups");
  },
};
